// Request log status values returned by the API
// These indicate the outcome of a request (success, warning, or error)
export type RequestLogStatus = "SUCCESS" | "WARNING" | "ERROR";

// Error types that can be returned when status is WARNING or ERROR
export type RequestErrorType =
  | "PROVIDER_TIMEOUT"
  | "PROVIDER_QUOTA_LIMIT"
  | "PROVIDER_RATE_LIMIT"
  | "PROVIDER_AUTH_ERROR"
  | "PROVIDER_ERROR"
  | "TEMPLATE_RENDER_ERROR"
  | "VARIABLE_MISSING_OR_EMPTY"
  | "UNKNOWN_ERROR";

// Human-readable labels for each error type
export const ERROR_TYPE_LABELS: Record<RequestErrorType, string> = {
  PROVIDER_TIMEOUT: "Provider Timeout",
  PROVIDER_QUOTA_LIMIT: "Quota Limit Exceeded",
  PROVIDER_RATE_LIMIT: "Rate Limit Exceeded",
  PROVIDER_AUTH_ERROR: "Authentication Error",
  PROVIDER_ERROR: "Provider Error",
  TEMPLATE_RENDER_ERROR: "Template Render Error",
  VARIABLE_MISSING_OR_EMPTY: "Missing or Empty Variable",
  UNKNOWN_ERROR: "Unknown Error",
};

// Style configurations for status display across components
export const STATUS_STYLES = {
  SUCCESS: {
    background: "bg-white",
    border: "border-gray-200",
    badge: "bg-green-100 text-green-700",
    icon: "text-green-600",
    dot: "bg-green-500",
  },
  WARNING: {
    background: "bg-amber-50",
    border: "border-amber-200",
    badge: "bg-amber-100 text-amber-700",
    icon: "text-amber-600",
    dot: "bg-amber-500",
  },
  ERROR: {
    background: "bg-red-50",
    border: "border-red-200",
    badge: "bg-red-100 text-red-700",
    icon: "text-red-600",
    dot: "bg-red-500",
  },
} as const;
